import $ from 'jquery';

class UnmuteHoverHandle {
    constructor() {
        this.player = window.player;
        this.$window = $(window);
    }

    handle() {
        if (this.player.muted()) {
            $('.icon-video-mute').remove();
            this.player.muted(false);
        }
        return;
    }

    // Set Listeners
    on() {
        this.$window.one('mouseenter', function unmute() {
            this.handle();
        }.bind(this));
    }
}

export default new UnmuteHoverHandle();
